import { render, staticRenderFns } from "./EmploymentTimesheetGrants.vue?vue&type=template&id=0834d17f&scoped=true&"
import script from "./EmploymentTimesheetGrants.vue?vue&type=script&lang=ts&"
export * from "./EmploymentTimesheetGrants.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0834d17f",
  null
  
)

export default component.exports